import {USER_ROLE} from "../constants";

const getPrettyUserRole = (userRole) => USER_ROLE[userRole]?.textValue || userRole;

export default getPrettyUserRole;
